import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
// import TelerikDataTable from "../../../../CommonComponents/TelerikDataTable/indexV2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
// import useSortedColumns from "../../../../utils/useSortedColumns";
// import AdvanceSearch from "../../../../CommonComponents/AdvanceSearch";
// import ErrorBoundary from "../../../../../../ErrorBoundry";
// import visileColumns from "./visibleColumns";
import {
  Autocomplete,
  Chip,
  createFilterOptions,
  Paper,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
// import EligibilityTable from "../Eligibility/EligibilityTable";
// import CustomizerContext from "../../../../_helper/Customizer";
// import StatusCell from "./StatusCell";
import visileColumns from "./visibleColumns";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import ErrorBoundary from "../../../ErrorBoundry";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable/indexV2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCertificate, faPaperPlaneTop } from "@fortawesome/pro-duotone-svg-icons";
import { post, get, put } from "../../../_helper/api_helper";
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import { ShowError, ShowSucess, getUserRole } from "../../../_helper/helper";
import { getFormalApiErrorMessage } from "../../../utils/apiError";
import axios from "axios";
import { format } from "date-fns";

const GA_READY_STATUS = "Ready for General Availability";
const normalizeGaStatus = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
const GA_READY_STATUS_NORMALIZED = normalizeGaStatus(GA_READY_STATUS);

// Kendo ExpansionPanel toggles on Space/Enter bubbling from any child, so typing in a field collapses it.
const stopPanelToggleKeys = (e) => {
  if (e.key === " " || e.key === "Enter") e.stopPropagation();
};

function CertificationDashboard() {
  // const { setEligibilityTableShow, EligibilityTableShow, setApplicantTableShow } = useContext(CustomizerContext);
  // const ANNOUNCEMENT_ID_Value = useMemo(()=>{
  //     // const {ANNOUNCEMENT_ID} = EligibilityTableShow
  //     if(EligibilityTableShow?.ANNOUNCEMENT_ID) return EligibilityTableShow.ANNOUNCEMENT_ID.trim()
  //     return ""
  // },[EligibilityTableShow])
  const dispatch = useDispatch();
  const history = useNavigate();
  const id = "ANNOUNCEMENTSDashboard";
  const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
  const { results, rowCount } = useMemo(() => {
    const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
    return {
      results: searchResult.results,
      rowCount: searchResult.rowCount,
    };
  }, [searchResultsV2, id]);
  const { userData } = useAuth();
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");

  const { sort } = useSelector((state) => state?.CommonReducer) || {};
  const [sortData, setSortData] = useState([
    { field: "created_on", dir: "desc" },
  ]);
  const [searchParams, setSearchParams] = useState([]);
  const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
  const [deleteData, setDeleteData] = useState(null);
  const [gg1ExportParams, setGG1ExportParams] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [toggleApiCall, setToggleApiCall] = useState(false);

  const [gaModalOpen, setGaModalOpen] = useState(false);
  const [gaModalAnnouncementId, setGaModalAnnouncementId] = useState("");
  const [gaEligibilityOptions, setGaEligibilityOptions] = useState([]);
  const [gaSelectedEligibilityId, setGaSelectedEligibilityId] = useState("");
  const [gaEligibilityFilterText, setGaEligibilityFilterText] = useState("");
  const [gaEligibilityLoader, setGaEligibilityLoader] = useState(false);
  const [gaJobOpenings, setGaJobOpenings] = useState(0);
  const [gaSubmitLoader, setGaSubmitLoader] = useState(false);
  const [gaExpandedEligibilityIds, setGaExpandedEligibilityIds] = useState([]);
  const [gaApplicantsByEligibility, setGaApplicantsByEligibility] = useState({});
  const [gaDepartments, setGaDepartments] = useState({ data: [], isLoading: true });
  const [gaDivisions, setGaDivisions] = useState({ data: [], isLoading: false });
  const [gaSelectedDepartment, setGaSelectedDepartment] = useState(null);
  const [gaSelectedDivision, setGaSelectedDivision] = useState(null);
  const [gaResponseDay, setGaResponseDay] = useState(0);
  const [gaTopScoreMatrix, setGaTopScoreMatrix] = useState("");
  const [gaComments, setGaComments] = useState("");
  const [gaGg1Options, setGaGg1Options] = useState({ data: [], isLoading: false });
  const [gaSelectedGG1, setGaSelectedGG1] = useState([]);
  const [gaGg1ConfirmationModal, setGaGg1ConfirmationModal] = useState(false);
  const [gaActivePanel, setGaActivePanel] = useState("eligibility");

  // Assign ASO - a single ASO assignment for the certification, keyed off
  // CERTIFICATION_PID. Options come from vw_all_members (dept-scoped), same
  // source CertificatePrepare.jsx's combined role modal uses for its member
  // search.
  const Role = getUserRole(userData);
  const [asoModalOpen, setAsoModalOpen] = useState(false);
  const [asoLoading, setAsoLoading] = useState(false);
  const [asoSubmitLoading, setAsoSubmitLoading] = useState(false);
  const [asoCurrentCert, setAsoCurrentCert] = useState(null);
  const [asoMembers, setAsoMembers] = useState([]);
  const [asoSelectedHrAso, setAsoSelectedHrAso] = useState(null);

  const { postingResult, loading } = useSelector(
    (state) => state.JobAnnouncementReducer
  );

  const getGaDepartments = async () => {
    try {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const response = await axios.post(
        `${newBaseURL}/AdvanceSearch/global`,
        {
          tableName: "LK_DPDV",
          searchParams: "[]",
          columns: "distinct Dept_Code, DepartmentName",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: "DepartmentName",
          sortBy: "asc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setGaDepartments({ data: response.data.results, isLoading: false });
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to retrieve department data at this time. Please try again shortly."
        )
      );
      setGaDepartments({ data: [], isLoading: false });
    }
  };

  const getGaDivisions = async (departmentCode) => {
    if (!departmentCode) return;
    setGaDivisions({ data: [], isLoading: true });
    try {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const response = await axios.post(
        `${newBaseURL}/AdvanceSearch/global`,
        {
          tableName: "LK_DPDV",
          searchParams: "[]",
          columns: "DEPT_KEY, NAME",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: "NAME",
          sortBy: "asc",
          additionalWhere: `Dept_Code = '${departmentCode}'`,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setGaDivisions({ data: response.data.results, isLoading: false });
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to retrieve division data at this time. Please try again shortly."
        )
      );
      setGaDivisions({ data: [], isLoading: false });
    }
  };

  const getGaGG1Options = async (deptCode, announcementId) => {
    setGaGg1Options({ data: [], isLoading: true });
    try {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const response = await axios.post(
        `${newBaseURL}/AdvanceSearch/global`,
        {
          tableName: "fn_GetGG1RecruitmentList",
          searchParams: `[{"columnName":"DeptCode","value":"${deptCode ?? ""}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"AnnouncementId","value":"${announcementId ?? ""}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
          columns: "*",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: 1,
          sortBy: "asc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setGaGg1Options({ data: response.data.results, isLoading: false });
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to retrieve GG1 recruitment data at this time. Please try again shortly."
        )
      );
      setGaGg1Options({ data: [], isLoading: false });
    }
  };

  useEffect(() => {
    getGaDepartments();
  }, []);

  useEffect(() => {
    if (gaSelectedDepartment?.value) {
      getGaDivisions(gaSelectedDepartment.value);
      getGaGG1Options(gaSelectedDepartment.value, gaModalAnnouncementId);
    } else {
      setGaDivisions({ data: [], isLoading: false });
      setGaGg1Options({ data: [], isLoading: false });
      setGaSelectedGG1([]);
    }
  }, [gaSelectedDepartment, gaModalAnnouncementId]);

  const gaDepartmentOptions = useMemo(() => {
    return gaDepartments.data
      .filter((item) => item.Dept_Code && item.DepartmentName)
      .map((item) => ({
        label: `${item.DepartmentName.trim()}(${item.Dept_Code})`,
        value: item.Dept_Code.trim(),
        payloadlabel: item.DepartmentName.trim(),
      }));
  }, [gaDepartments.data]);

  const gaDivisionOptions = useMemo(() => {
    return gaDivisions.data
      .filter((item) => item.DEPT_KEY && item.NAME)
      .map((item) => ({
        label: `${item.NAME.trim()}(${item.DEPT_KEY})`,
        value: item.DEPT_KEY.trim(),
        payloadlabel: item.NAME.trim(),
      }));
  }, [gaDivisions.data]);

  const gaFilterOptions = useMemo(
    () =>
      createFilterOptions({
        matchFrom: "any",
        stringify: (option) => option.label,
      }),
    []
  );

  const actions = useMemo(() => {
    return [
      {
        title: "Generate General Availability",
        icon: { iconName: "k-icon k-i-plus" },
        className: "font-primary",
        style: { cursor: "pointer" },
        action: async (props) => {
          const { ANNOUNCEMENT_ID } = props.dataItem;
          const annId = ANNOUNCEMENT_ID?.trim() ?? "";
          setGaModalAnnouncementId(annId);
          setGaJobOpenings(0);
          setGaEligibilityOptions([]);
          setGaSelectedEligibilityId("");
          setGaEligibilityFilterText("");
          setGaExpandedEligibilityIds([]);
          setGaApplicantsByEligibility({});
          setGaSelectedDepartment(null);
          setGaSelectedDivision(null);
          setGaResponseDay(0);
          setGaComments("");
          setGaSelectedGG1([]);
          setGaGg1ConfirmationModal(false);
          setGaActivePanel("eligibility");
          setGaModalOpen(true);
          setGaEligibilityLoader(true);
          try {
            const params = [
              {
                columnName: "ANNOUNCEMENT_ID",
                value: annId,
                operator: "=",
                dataType: "char",
                logicOperator: "AND",
              },
            ];
            const payload = {
              tableName: "EligibilitySummaryByAnnouncementID",
              searchParams: JSON.stringify(params),
              columns: "*",
              location: "pmis-global",
              pageNumber: 1,
              pageSize: 1000,
              sortData: "",
              additionalWhere: "",
              qID: 0,
            };
            const response = await advanceSearch(payload);

            const uniqueRowsById = new Map();
            (response?.results ?? []).forEach((row) => {
              const eligId = row?.EligibilityID?.trim();
              if (eligId && !uniqueRowsById.has(eligId)) {
                uniqueRowsById.set(eligId, {
                  eligibility_id: eligId,
                  profilename: row?.ProfileName,
                  applicantCount: Number(row?.No_of_Applicant) || 0,
                  generalAvailabilityIds: row?.GeneralAvailabilityIDs,
                  createdDate: row?.Elig_CreatedDate,
                  status: String(row?.STATUS ?? "").trim(),
                });
              }
            });

            setGaEligibilityOptions([...uniqueRowsById.values()]);
          } catch (error) {
            ShowError(
              getFormalApiErrorMessage(
                error,
                "We are unable to load eligibility details for this announcement at this time."
              )
            );
          } finally {
            setGaEligibilityLoader(false);
          }
        },
        // An announcement can have multiple GAs, so this stays available even once one exists.
        isVisible: () => true,
      },
      {
        title: "View Details",
        icon: { iconName: "k-icon k-i-eye" }, // This is the Kendo UI eye icon
        className: "font-primary", // Uses the same style as your commented-out code
        style: { cursor: "pointer" },
        action: (props) => {
          // 1. Get all three values from the row's dataItem
          const {
            ANNOUNCEMENT_ID,
            GENERAL_AVAILIBILITY_ID,
            CERTIFICATION_PID
          } = props.dataItem;

          // 2. Handle potential null/undefined values by defaulting to an empty string
          const annId = ANNOUNCEMENT_ID?.trim() ?? '';
          const gaId = GENERAL_AVAILIBILITY_ID ?? '';
          const certPid = CERTIFICATION_PID ?? '';

          // 3. Navigate to the new URL.
          //    *** IMPORTANT: Change '/certification-details/' to your real route! ***

          // This method uses the main ID as part of the path and the other two
          // as query parameters. This is a very clean way to handle optional/null values.
          history(`/certification-details/${encodeURIComponent(annId)}?gaId=${gaId}&certPid=${certPid}`);

          /* // --- Alternative Method (if you prefer all in the path) ---
          // You could also do this, but it's less clean if values are empty:
          // history(`/certification-details/${annId}/${gaId}/${certPid}`);
          */
        },
        // Only meaningful once a GA exists for this announcement.
        isVisible: (dataItem) => Boolean(dataItem?.GENERAL_AVAILIBILITY_ID),
      },
      {
        title: "Assign ASO",
        icon: { iconName: "k-icon k-i-user" },
        className: "font-primary",
        style: { cursor: "pointer" },
        action: (props) => {
          toggleAsoModal(props.dataItem);
        },
        // Only relevant once a GA, certification, and announcement all exist
        // for this row, and only for the roles allowed to perform ASO
        // assignment (mirrors CertificatePrepare's "Assign Members" gating).
        isVisible: (dataItem) =>
          Boolean(dataItem?.GENERAL_AVAILIBILITY_ID) &&
          Boolean(dataItem?.CERTIFICATION_PID) &&
          Boolean(dataItem?.ANNOUNCEMENT_ID) &&
          ["SUPER-USER", "HR-Recruitment"].includes(Role),
      },
    ];
    // toggleAsoModal is intentionally omitted: it's declared further down but
    // only ever called from inside these action closures (never invoked while
    // this memo runs), and it doesn't close over any state that changes across
    // renders other than through stable setters, so a stale reference is safe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, Role]); // <-- IMPORTANT: Added 'history' (from useNavigate) to the dependency array

  // ASO row's member search is scoped to the logged-in user's own
  // department(s), same restriction CertificatePrepare.jsx's combined role
  // modal applies to its vw_all_members search.
  const getAsoDeptCodeSearchParam = () => {
    const raw = userData?.profile?.DEPT_CODE;
    const deptCodes = (Array.isArray(raw) ? raw : raw ? [raw] : []).filter(Boolean);
    if (!deptCodes.length) return null;
    return {
      columnName: "Dept_no",
      value: deptCodes.join(","),
      operator: "=",
      dataType: "varchar(MAX)",
      logicOperator: "AND",
    };
  };

  const getAsoMembers = async () => {
    const deptCodeParam = getAsoDeptCodeSearchParam();
    try {
      const response = await advanceSearch({
        tableName: "vw_all_members_aso",
        searchParams: JSON.stringify(deptCodeParam ? [deptCodeParam] : []),
        columns: "*",
        location: "global",
        pageNumber: 1,
        pageSize: 5000,
        sortData: "",
        additionalWhere: "",
        qID: 0,
      });
      // vw_all_members can return more than one row for the same employee ID
      // (e.g. multiple department/position assignments) - dedupe by ID only,
      // since two different employees can genuinely share the same name.
      const uniqueMembersById = new Map();
      (response?.results ?? []).forEach((member) => {
        const key = member?.ID;
        if (key != null && !uniqueMembersById.has(key)) {
          uniqueMembersById.set(key, member);
        }
      });
      const sortedMembers = [...uniqueMembersById.values()].sort((a, b) =>
        (a?.EmployeeName_LFM || "").localeCompare(b?.EmployeeName_LFM || "")
      );
      setAsoMembers(sortedMembers);
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load member details at this time. Please try again shortly."
        )
      );
    }
  };

  // Includes the Employee ID so two different people who happen to share the
  // same name (confirmed to exist in vw_all_members) are still distinguishable.
  const getAsoMemberOptionLabel = (option) =>
    option?.EmployeeName_LFM
      ? `${option.EmployeeName_LFM}${option.PositionTitle ? ` - ${option.PositionTitle}` : ""}${option.ID ? ` (ID: ${option.ID})` : ""}`
      : "";

  const clearAsoForm = () => {
    setAsoCurrentCert(null);
    setAsoSelectedHrAso(null);
  };

  // Opens the Assign ASO modal for a dashboard row (fetches the full
  // certification record fresh, since the dashboard grid doesn't carry the
  // Agency_Approvel_request/Agency_Director/Point_of_Contact fields the
  // assignment flow needs), or closes it when called with no row.
  const toggleAsoModal = async (row = null) => {
    if (asoModalOpen || !row) {
      setAsoModalOpen(false);
      clearAsoForm();
      return;
    }
    // Visible once a GA exists, but a certification may not have been
    // created for it yet - that's a distinct condition from CERTIFICATION_PID
    // just not being on this dashboard row's data.
    if (!row.CERTIFICATION_PID) {
      ShowError("No certification exists yet for this announcement.");
      return;
    }

    const certPid = row.CERTIFICATION_PID;
    setAsoLoading(true);
    try {
      const certResponse = await advanceSearch({
        tableName: "CERT-LIST",
        searchParams: JSON.stringify([
          {
            columnName: "CERTIFICATION_PID",
            value: certPid,
            operator: "=",
            dataType: "varchar(MAX)",
            logicOperator: "AND",
          },
        ]),
        columns: "*",
        location: "pmis-global",
        pageNumber: 1,
        pageSize: 1,
        sortData: "",
        additionalWhere: "",
        qID: 0,
      });
      const cert = certResponse?.results?.[0];
      if (!cert) {
        ShowError("We are unable to load this certification's details right now.");
        return;
      }
      if (cert.Return_To_HR) {
        ShowError("Certification is already done, Now you can't re-assign ASO.");
        return;
      }
      await getAsoMembers();
      setAsoCurrentCert(cert);
      setAsoSelectedHrAso(null);
      setAsoModalOpen(true);
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load this certification's assignment details at this time."
        )
      );
    } finally {
      setAsoLoading(false);
    }
  };

  const handleAssignAso = async () => {
    if (!asoSelectedHrAso) {
      ShowError("Please select an ASO.");
      return;
    }

    const payload = {
      certificatioN_PID: asoCurrentCert?.CERTIFICATION_PID,
      announcemenT_ID: asoCurrentCert?.ANNOUNCEMENT_ID,

      Hr_ASO: asoSelectedHrAso?.EmployeeName_LFM,
      Hr_ASO_empid: Number(asoSelectedHrAso?.ID),
      Hr_ASO_PositionTitle: asoSelectedHrAso?.PositionTitle || "",

      // This dashboard's Assign ASO flow doesn't offer a panelist picker, so no
      // panelists are ever sent through it.
      panelists: [],
    };

    setAsoSubmitLoading(true);
    try {
      await put(
        `${process.env.REACT_APP_API_DOTNET_URL}/PMISCERT_AsoAssignment/AddorUpdate_PMISCertAsoAssignment`,
        payload
      );
      ShowSucess("ASO assigned successfully");
      setAsoModalOpen(false);
      clearAsoForm();
      setToggleApiCall((prev) => !prev);
    } catch (error) {
      ShowError(getFormalApiErrorMessage(error, "Submission failed"));
    } finally {
      setAsoSubmitLoading(false);
    }
  };

  const toggleGaModal = () => setGaModalOpen((prev) => !prev);

  const [gaEligibilitySortField, setGaEligibilitySortField] = useState(null);
  const [gaEligibilitySortDir, setGaEligibilitySortDir] = useState("asc");

  const handleEligibilitySort = (field) => {
    if (gaEligibilitySortField === field) {
      setGaEligibilitySortDir((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setGaEligibilitySortField(field);
      setGaEligibilitySortDir("asc");
    }
  };

  const renderSortableEligibilityHeader = (label, field, className, width) => (
    <th
      className={className}
      style={{ cursor: "pointer", userSelect: "none", width }}
      onClick={() => handleEligibilitySort(field)}
    >
      {label}
      {gaEligibilitySortField === field &&
        (gaEligibilitySortDir === "asc" ? " ▲" : " ▼")}
    </th>
  );

  const filteredGaEligibilityOptions = useMemo(() => {
    const filterText = gaEligibilityFilterText.trim().toLowerCase();
    let options = gaEligibilityOptions;
    if (filterText) {
      options = options.filter((opt) =>
        [opt.eligibility_id, opt.profilename, opt.status]
          .filter(Boolean)
          .some((value) => value.toLowerCase().includes(filterText))
      );
    }
    if (gaEligibilitySortField) {
      const dir = gaEligibilitySortDir === "asc" ? 1 : -1;
      options = [...options].sort((a, b) => {
        const aVal = a[gaEligibilitySortField];
        const bVal = b[gaEligibilitySortField];
        if (typeof aVal === "number" || typeof bVal === "number") {
          return ((aVal || 0) - (bVal || 0)) * dir;
        }
        if (gaEligibilitySortField === "eligibility_id") {
          // IDs look like "EI00-0812" — sort by the trailing segment
          // (0812, 0813, ...) rather than the leading one.
          const trailingNumber = (id) => {
            const match = String(id || "").match(/(\d+)(?!.*\d)/);
            return match ? Number(match[1]) : 0;
          };
          return (trailingNumber(aVal) - trailingNumber(bVal)) * dir;
        }
        if (gaEligibilitySortField === "createdDate") {
          const aTime = aVal ? new Date(aVal).getTime() : 0;
          const bTime = bVal ? new Date(bVal).getTime() : 0;
          return ((aTime || 0) - (bTime || 0)) * dir;
        }
        return (
          String(aVal || "").localeCompare(String(bVal || ""), undefined, {
            numeric: true,
          }) * dir
        );
      });
    }
    return options;
  }, [
    gaEligibilityOptions,
    gaEligibilityFilterText,
    gaEligibilitySortField,
    gaEligibilitySortDir,
  ]);

  const gaSelectedApplicantCount =
    gaEligibilityOptions.find(
      (opt) => opt.eligibility_id === gaSelectedEligibilityId
    )?.applicantCount || 0;

  const gaSelectedEligibilityApplicants =
    gaApplicantsByEligibility[gaSelectedEligibilityId]?.applicants ?? [];

  // Top Score matrix N means the top N distinct Evaluation Rating values are
  // notified, plus one more rating level below that (the "+1" rule). Ranking
  // is by distinct score value, not raw applicant position, so ties at any
  // level (including the cutoff level) never split — everyone sharing an
  // included score is notified, even if that grows the list well past N+1.
  const getTopScoreNotifyCount = (applicants, topN) => {
    if (!topN || topN <= 0 || applicants.length === 0) return null;
    const uniqueScoresDesc = [
      ...new Set(applicants.map((a) => Number(a?.evaluation_rating) || 0)),
    ].sort((a, b) => b - a);
    const cutoffScore = uniqueScoresDesc[Math.min(topN, uniqueScoresDesc.length - 1)];
    return applicants.filter(
      (applicant) => (Number(applicant?.evaluation_rating) || 0) >= cutoffScore
    ).length;
  };

  const gaTopScoreNotifyCount = getTopScoreNotifyCount(
    gaSelectedEligibilityApplicants,
    Number(gaTopScoreMatrix) || 0
  );

  // Falls back to notifying all eligible candidates until a Top Score matrix
  // value is entered and applicant ratings have loaded.
  const gaNotifyCount = gaTopScoreNotifyCount ?? gaSelectedApplicantCount;

  const formatMDY = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "" : format(date, "MM/dd/yyyy");
  };

  const ensureApplicantsLoaded = async (eligId) => {
    if (!eligId || gaApplicantsByEligibility[eligId]) return;

    setGaApplicantsByEligibility((prev) => ({
      ...prev,
      [eligId]: { loading: true, applicants: [] },
    }));
    try {
      const payload = {
        tableName: "applicant-by-annountment-eligiblity",
        searchParams: JSON.stringify([
          {
            columnName: "announcement_id",
            value: gaModalAnnouncementId,
            operator: "=",
            dataType: "varchar(50)",
            logicOperator: "AND",
          },
          {
            columnName: "eligibility_list",
            value: eligId,
            operator: "=",
            dataType: "varchar(500)",
            logicOperator: "AND",
          },
        ]),
        columns: "*",
        location: "pmis-global",
        pageNumber: 1,
        pageSize: 500,
        sortData: "",
        additionalWhere: "",
        qID: 0,
      };
      const response = await advanceSearch(payload);
      const sortedApplicants = [...(response?.results ?? [])].sort(
        (a, b) => (Number(b?.evaluation_rating) || 0) - (Number(a?.evaluation_rating) || 0)
      );
      setGaApplicantsByEligibility((prev) => ({
        ...prev,
        [eligId]: { loading: false, applicants: sortedApplicants },
      }));
    } catch (error) {
      setGaApplicantsByEligibility((prev) => ({
        ...prev,
        [eligId]: { loading: false, applicants: [], error: true },
      }));
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load applicants for this eligibility list at this time."
        )
      );
    }
  };

  // Applicant ratings are needed to compute the Top Score matrix notify count
  // as soon as an eligibility list is selected, not only when its row is expanded.
  useEffect(() => {
    if (gaSelectedEligibilityId) {
      ensureApplicantsLoaded(gaSelectedEligibilityId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gaSelectedEligibilityId]);

  const toggleEligibilityExpand = async (eligId) => {
    const isExpanded = gaExpandedEligibilityIds.includes(eligId);
    if (isExpanded) {
      setGaExpandedEligibilityIds((prev) => prev.filter((id) => id !== eligId));
      return;
    }

    setGaExpandedEligibilityIds((prev) => [...prev, eligId]);
    await ensureApplicantsLoaded(eligId);
  };

  const [gaNotifiedModalOpen, setGaNotifiedModalOpen] = useState(false);

  const openNotifiedApplicantsModal = async () => {
    setGaNotifiedModalOpen(true);
    await ensureApplicantsLoaded(gaSelectedEligibilityId);
  };

  const gaRequiredGG1Count = Number(gaJobOpenings) || 0;
  const gaHasSelectedGG1 = gaSelectedGG1.length > 0;
  const gaIsGG1SelectionValid =
    !gaHasSelectedGG1 ||
    (gaRequiredGG1Count > 0 && gaSelectedGG1.length === gaRequiredGG1Count);
  const gaVacancyExceedsEligible =
    gaSelectedEligibilityId &&
    Number(gaJobOpenings) > 0 &&
    Number(gaJobOpenings) > gaSelectedApplicantCount;
  const gaSubmitDisabled =
    gaJobOpenings == 0 ||
    gaResponseDay == 0 ||
    gaSubmitLoader ||
    gaEligibilityLoader ||
    !gaSelectedEligibilityId ||
    gaVacancyExceedsEligible ||
    (gaHasSelectedGG1 && !gaIsGG1SelectionValid);

  const gaSubmitDisabledReason = gaEligibilityLoader
    ? "Eligibility details are still loading."
    : !gaSelectedEligibilityId
      ? "Select an eligibility list first."
      : gaJobOpenings == 0
        ? "Enter a Number of Vacancies greater than 0."
        : gaResponseDay == 0
          ? "Enter an Applicant Response Day Limit greater than 0."
          : gaVacancyExceedsEligible
            ? `Number of Vacancies (${Number(gaJobOpenings)}) cannot exceed the total eligible applicants (${gaSelectedApplicantCount}).`
            : gaHasSelectedGG1 && !gaIsGG1SelectionValid
              ? `Please select exactly ${gaRequiredGG1Count} GG1 recruitment record(s). Currently selected: ${gaSelectedGG1.length}.`
              : gaSubmitLoader
                ? "Submitting..."
                : "";

  const gaSharedSubmitPayload = (hrControls) => ({
    announcement_id: gaModalAnnouncementId,
    eligibility_list: gaSelectedEligibilityId,
    // applicant_to_include: (Number(gaTopScoreMatrix) || 0) + 1,
    applicant_to_include: gaNotifyCount,
    general_avaibility_id: "0",
    vacancy: Number(gaJobOpenings),
    department: gaSelectedDepartment?.value,
    division: gaSelectedDivision?.value,
    departmentName: gaSelectedDepartment?.payloadlabel?.trim(),
    divisionName: gaSelectedDivision?.payloadlabel?.trim(),
    comment: gaComments,
    hr_controls: hrControls,
    responseDay: Number(gaResponseDay),
  });

  const submitGaWithoutGG1 = async () => {
    try {
      setGaSubmitLoader(true);
      const nrResponse = await get(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateNrHrControlIds?Noofvacancies=${Number(gaJobOpenings)}`,
        {}
      );
      const hrControls = Array.isArray(nrResponse?.hrcontrols)
        ? nrResponse.hrcontrols.join(",")
        : "";
      await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateGeneralAvaibility`,
        gaSharedSubmitPayload(hrControls)
      );
      ShowSucess("General Availability generated successfully");
      setToggleApiCall((prev) => !prev);
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to generate the General Availability at this time. Please try again shortly."
        )
      );
    } finally {
      setGaSubmitLoader(false);
      setGaGg1ConfirmationModal(false);
      setGaModalOpen(false);
    }
  };

  const submitGaWithGG1 = async () => {
    try {
      setGaSubmitLoader(true);
      const hrControls = gaSelectedGG1.map((g) => g.value.HrControl).join(",");
      await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateGeneralAvaibility`,
        gaSharedSubmitPayload(hrControls)
      );
      ShowSucess("General Availability generated successfully");
      setToggleApiCall((prev) => !prev);
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to generate the General Availability at this time. Please try again shortly."
        )
      );
    } finally {
      setGaSubmitLoader(false);
      setGaGg1ConfirmationModal(false);
      setGaModalOpen(false);
    }
  };

  const handleGaModalSubmit = async () => {
    if (!gaSelectedEligibilityId) {
      ShowError("Please select an eligibility list.");
      return;
    }
    if (!gaRequiredGG1Count) {
      ShowError("Please enter number of vacancy greater than 0");
      return;
    }
    if (gaVacancyExceedsEligible) {
      ShowError(
        `Number of Vacancies (${Number(gaJobOpenings)}) cannot exceed the total eligible applicants (${gaSelectedApplicantCount}).`
      );
      return;
    }
    if (!Number(gaResponseDay)) {
      ShowError("Please enter applicant response day limit greater than 0");
      return;
    }
    if (!gaHasSelectedGG1) {
      setGaGg1ConfirmationModal(true);
      return;
    }
    if (!gaIsGG1SelectionValid) {
      ShowError(
        `Please select exactly ${gaRequiredGG1Count} GG1 recruitment record(s). Currently selected: ${gaSelectedGG1.length}`
      );
      return;
    }
    await submitGaWithGG1();
  };


  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);

  // const columnWithStatus = useMemo(() => {
  //     return visileColumns.map((item) => {
  //         if (item.field === 'status') {
  //             return {
  //                 ...item,
  //                 headerClassName: 'text-center',
  //                 className: 'd-flex align-items-center justify-content-center',
  //                 cell: (props) => (
  //                     <StatusCell dataItem={props.dataItem} GA={GA} />
  //                 )
  //             };
  //         }
  //         return item;
  //     });
  // }, [GA]);

  const renderMultiValueCell = (fieldName, visibleCount) => (props) => {
    const raw = props.dataItem?.[fieldName] || "";
    const values = raw
      .split(",")
      .map((val) => val.trim())
      .filter(Boolean);

    if (values.length === 0) {
      return <td className={props.className}></td>;
    }
    if (values.length <= visibleCount) {
      return <td className={props.className}>{values.join(", ")}</td>;
    }
    return (
      <td className={props.className}>
        <Tooltip title={values.join(", ")} arrow>
          <span style={{ cursor: "pointer", textDecoration: "underline dotted" }}>
            {values.slice(0, visibleCount).join(", ")}, +{values.length - visibleCount} more
          </span>
        </Tooltip>
      </td>
    );
  };

  const renderEligibilityIdsCell = renderMultiValueCell("ELIGIBILITY_IDs", 3);
  const renderGARecruitmentHrControlsCell = renderMultiValueCell(
    "GARecruitment_HrControls",
    1
  );

  const initialColumns = useMemo(
    () =>
      visileColumns.map((col) => {
        if (col.field === "ELIGIBILITY_IDs") {
          return { ...col, cell: renderEligibilityIdsCell };
        }
        if (col.field === "GARecruitment_HrControls") {
          return { ...col, cell: renderGARecruitmentHrControlsCell };
        }
        return col;
      }),
    []
  );

  const [sortedColumns, setSortedColumns] = useState(initialColumns);

  // const [sortedColumns, setSortedColumns] = useSortedColumns(
  //     id,
  //     ColumnsSorted,
  //     [],
  //     visileColumns,
  //     userData
  // );

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };

  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    setPageSize(100);
  };

  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
    setPageSize(100);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  return (
    <ErrorBoundary>
      <Fragment>
        <Container fluid={true}>
          <Row className="bg-primary rounded py-2 mb-3 sticky-top">
            <Col className="d-flex align-items-center gap-2">
              <FontAwesomeIcon icon={faCertificate} size="xl" />
              <Typography variant="h6" style={{ color: "white" }}>
                Recruitment Dashboard
              </Typography>
            </Col>
          </Row>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                {/* <CardHeader>
                                    <div className="d-flex align-items-center">
                                        <div className="w-100">
                                            <h5 className="m-0">Job Announcements List</h5>
                                        </div>
                                    </div>
                                </CardHeader> */}
                <CardBody>
                  <div>
                    <TelerikDataTable
                      id={id}
                      pageNumber={page}
                      pageSize={pageSize}
                      totalCount={rowCount}
                      skip={(page - 1) * pageSize}
                      take={pageSize}
                      data={results || []}
                      sortData={sortData}
                      tableName={"GettDetails"}
                      searchParams={searchParams}
                      additionalWhere={additionalWhere}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      selectedColumns={sortedColumns}
                      setSortedColumns={setSortedColumns}
                      loading={loadingSearch}
                      enableFooterCell={false}
                      dataLocation="pmis-global"
                      actions={actions}
                      toggleApiCall={toggleApiCall}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal isOpen={gaModalOpen} toggle={toggleGaModal} size="xl" backdrop="static" keyboard={false}>
          <ModalHeader toggle={toggleGaModal}>
            Generate General Availability
          </ModalHeader>
          <ModalBody>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <Input value={gaModalAnnouncementId} disabled />

              <ExpansionPanel
                title={
                  <span style={{ color: "var(--theme-default)" }}>
                    Select an Eligibility List
                  </span>
                }
                subtitle={
                  gaSelectedEligibilityId
                    ? `Selected: ${gaSelectedEligibilityId}`
                    : "None selected"
                }
                expanded={gaActivePanel === "eligibility"}
                onAction={() =>
                  setGaActivePanel((prev) =>
                    prev === "eligibility" ? "" : "eligibility"
                  )
                }
              >
                {gaActivePanel === "eligibility" && (
                  <ExpansionPanelContent onKeyDown={stopPanelToggleKeys}>
                    {gaEligibilityLoader ? (
                      <div className="d-flex align-items-center gap-2">
                        <Spinner size="sm" /> Loading eligibility details...
                      </div>
                    ) : gaEligibilityOptions.length === 0 ? (
                      <div className="text-danger">
                        No eligibility list was found for this announcement.
                      </div>
                    ) : (
                      <div>
                        <Input
                          type="text"
                          value={gaEligibilityFilterText}
                          onChange={(e) => setGaEligibilityFilterText(e.target.value)}
                          placeholder="Filter by eligibility ID, job profile, or status"
                          className="my-2"
                        />
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                          <Table size="sm" borderless className="mb-2">
                            <thead>
                              <tr>
                                <th style={{ width: "30px" }}></th>
                                <th style={{ width: "30px" }}></th>
                                {renderSortableEligibilityHeader(
                                  "Eligibility ID",
                                  "eligibility_id",
                                  undefined,
                                  "12%"
                                )}
                                {renderSortableEligibilityHeader(
                                  "Job Profile",
                                  "profilename",
                                  undefined,
                                  "20%"
                                )}
                                {renderSortableEligibilityHeader(
                                  "Applicants",
                                  "applicantCount",
                                  "text-end",
                                  "10%"
                                )}
                                {renderSortableEligibilityHeader(
                                  "Existing GA(s)",
                                  "generalAvailabilityIds",
                                  undefined,
                                  "22%"
                                )}
                                {renderSortableEligibilityHeader(
                                  "Created Date",
                                  "createdDate",
                                  undefined,
                                  "12%"
                                )}
                                {renderSortableEligibilityHeader(
                                  "Status",
                                  "status",
                                  undefined,
                                  "14%"
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {filteredGaEligibilityOptions.length === 0 ? (
                                <tr>
                                  <td colSpan={8} className="text-muted">
                                    No eligibility list matches this filter.
                                  </td>
                                </tr>
                              ) : (
                                filteredGaEligibilityOptions.map((opt) => {
                                  const isExpanded = gaExpandedEligibilityIds.includes(
                                    opt.eligibility_id
                                  );
                                  const applicantState =
                                    gaApplicantsByEligibility[opt.eligibility_id];
                                  const isSelected =
                                    gaSelectedEligibilityId === opt.eligibility_id;
                                  const isSelectable =
                                    normalizeGaStatus(opt.status) ===
                                    GA_READY_STATUS_NORMALIZED;
                                  // Bootstrap's .table rules paint an opaque
                                  // background on every <td>, which sits on top of
                                  // and hides a background set on the parent <tr>.
                                  // Apply the highlight per-cell instead.
                                  const rowHighlightStyle = isSelected
                                    ? { backgroundColor: "#e7f1ff" }
                                    : undefined;
                                  return (
                                    <Fragment key={opt.eligibility_id}>
                                      <tr>
                                        <td style={rowHighlightStyle}>
                                          <Input
                                            type="radio"
                                            name="ga-eligibility-select"
                                            checked={isSelected}
                                            disabled={!isSelectable}
                                            style={
                                              isSelected
                                                ? {
                                                  backgroundColor:
                                                    "var(--theme-default)",
                                                  border:
                                                    "1px solid var(--theme-default)",
                                                }
                                                : { borderColor: "#6c757d" }
                                            }
                                            title={
                                              isSelectable
                                                ? undefined
                                                : `Only eligibility lists with status "${GA_READY_STATUS}" can be selected.`
                                            }
                                            onChange={() => {
                                              if (!isSelectable) return;
                                              setGaSelectedEligibilityId(
                                                opt.eligibility_id
                                              );
                                              setGaActivePanel("details");
                                            }}
                                          />
                                        </td>
                                        <td style={rowHighlightStyle}>
                                          <span
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              toggleEligibilityExpand(
                                                opt.eligibility_id
                                              )
                                            }
                                          >
                                            {isExpanded ? "▾" : "▸"}
                                          </span>
                                        </td>
                                        <td style={rowHighlightStyle}>{opt.eligibility_id}</td>
                                        <td
                                          style={{
                                            ...rowHighlightStyle,
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {opt.profilename || ""}
                                        </td>
                                        <td
                                          className="text-end"
                                          style={rowHighlightStyle}
                                        >
                                          {opt.applicantCount}
                                        </td>
                                        <td style={rowHighlightStyle}>{opt.generalAvailabilityIds || ""}</td>
                                        <td style={rowHighlightStyle}>{formatMDY(opt.createdDate)}</td>
                                        <td
                                          style={{
                                            ...rowHighlightStyle,
                                            color: isSelectable
                                              ? "#28a745"
                                              : "#dc3545",
                                          }}
                                        >
                                          {opt.status || ""}
                                        </td>
                                      </tr>
                                      {isExpanded && (
                                        <tr>
                                          <td></td>
                                          <td colSpan={7}>
                                            {applicantState?.loading ? (
                                              <div className="d-flex align-items-center gap-2">
                                                <Spinner size="sm" /> Loading
                                                applicants...
                                              </div>
                                            ) : applicantState?.error ? (
                                              <div className="text-danger">
                                                Unable to load applicants for this
                                                eligibility list.
                                              </div>
                                            ) : applicantState?.applicants
                                              ?.length === 0 ? (
                                              <div className="text-muted">
                                                No applicants found.
                                              </div>
                                            ) : (
                                              <>
                                                <div
                                                  className="text-muted mb-1"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  Sorted by evaluation rating
                                                  (highest first).{" "}
                                                  <span
                                                    style={{
                                                      backgroundColor: "#d4edda",
                                                      padding: "0 6px",
                                                    }}
                                                  >
                                                    Highlighted
                                                  </span>{" "}
                                                  = all {gaNotifyCount} eligible
                                                  candidate(s) who will be notified.
                                                </div>
                                                <Table size="sm" bordered responsive>
                                                  <thead>
                                                    <tr>
                                                      <th>First Name</th>
                                                      <th>Last Name</th>
                                                      <th>Application ID</th>
                                                      <th>Evaluation Rating</th>
                                                      <th>Update Status</th>
                                                      <th>Application Date</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {applicantState?.applicants.map(
                                                      (applicant, index) => {
                                                        // Same Bootstrap cell-background
                                                        // override as above — style each
                                                        // <td>, not the <tr>.
                                                        const highlightStyle =
                                                          index < gaNotifyCount
                                                            ? {
                                                              backgroundColor:
                                                                "#d4edda",
                                                            }
                                                            : undefined;
                                                        return (
                                                          <tr
                                                            key={
                                                              applicant.application_id ||
                                                              index
                                                            }
                                                          >
                                                            <td style={highlightStyle}>{applicant.fname}</td>
                                                            <td style={highlightStyle}>{applicant.lname}</td>
                                                            <td style={highlightStyle}>
                                                              {applicant.application_id}
                                                            </td>
                                                            <td style={highlightStyle}>
                                                              {
                                                                applicant.evaluation_rating
                                                              }
                                                            </td>
                                                            <td style={highlightStyle}>
                                                              {applicant.update_status}
                                                            </td>
                                                            <td style={highlightStyle}>
                                                              {formatMDY(
                                                                applicant.application_date
                                                              )}
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                </Table>
                                              </>
                                            )}
                                          </td>
                                        </tr>
                                      )}
                                    </Fragment>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                  </ExpansionPanelContent>
                )}
              </ExpansionPanel>

              <ExpansionPanel
                title={
                  <span style={{ color: "var(--theme-default)" }}>
                    Vacancy & Recruitment Details
                  </span>
                }
                subtitle={
                  !gaSelectedEligibilityId
                    ? "Select an eligibility list first"
                    : undefined
                }
                disabled={!gaSelectedEligibilityId}
                expanded={gaActivePanel === "details"}
                onAction={() =>
                  setGaActivePanel((prev) =>
                    prev === "details" ? "" : "details"
                  )
                }
              >
                {gaActivePanel === "details" && (
                  <ExpansionPanelContent onKeyDown={stopPanelToggleKeys}>
                    <div
                      style={{ display: "flex", flexDirection: "column", gap: "8px" }}
                    >
                      <Autocomplete
                        options={gaDepartmentOptions}
                        loading={gaDepartments.isLoading}
                        filterOptions={gaFilterOptions}
                        getOptionLabel={(option) => option.label || ""}
                        value={gaSelectedDepartment}
                        onChange={(event, newValue) => {
                          setGaSelectedDepartment(newValue);
                          setGaSelectedDivision(null);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Department"
                            variant="outlined"
                            size="small"
                          />
                        )}
                      />

                      <Autocomplete
                        options={gaDivisionOptions}
                        filterOptions={gaFilterOptions}
                        loading={gaDivisions.isLoading}
                        getOptionLabel={(option) => option.label || ""}
                        value={gaSelectedDivision}
                        onChange={(event, newValue) => setGaSelectedDivision(newValue)}
                        size="small"
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                        disabled={!gaSelectedDepartment}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Division"
                            variant="outlined"
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <Fragment>
                                  {gaDivisions.isLoading ? (
                                    <Spinner size="sm" />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </Fragment>
                              ),
                            }}
                          />
                        )}
                      />

                      <TextField
                        type="number"
                        label="Number Of Vacancies"
                        value={gaJobOpenings}
                        onChange={(e) => setGaJobOpenings(e.target.value)}
                        placeholder="Enter number of Vacancies"
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={gaEligibilityLoader || gaEligibilityOptions.length === 0}
                        error={gaVacancyExceedsEligible}
                        helperText={
                          gaVacancyExceedsEligible
                            ? `Cannot exceed total eligible applicants (${gaSelectedApplicantCount}).`
                            : ""
                        }
                      />

                      <TextField
                        type="number"
                        label="Applicant Response Day Limit"
                        required
                        value={gaResponseDay}
                        onChange={(e) => setGaResponseDay(e.target.value)}
                        placeholder="Enter number of Response Days"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                      {/* <TextField
                        type="number"
                        label="Top Score matrix"
                        required
                        value={gaTopScoreMatrix}
                        onChange={(e) => setGaTopScoreMatrix(e.target.value)}
                        placeholder="Enter top score matrix"
                        variant="outlined"
                        size="small"
                        fullWidth
                      /> */}
                      {Number(gaTopScoreMatrix) > 0 && (
                        <div style={{ color: "#6c757d", fontSize: "12px" }}>
                          Top {Number(gaTopScoreMatrix) + 1} applicant(s) by
                          Evaluation Rating will be included; any applicant with a tied score is also included.
                        </div>
                      )}

                      <Autocomplete
                        multiple
                        options={gaGg1Options.data.map((item) => ({
                          label: item.To_Department
                            ? `${item.HrControl} (${item.To_Department.trim()})`
                            : item.HrControl,
                          value: item,
                        }))}
                        loading={gaGg1Options.isLoading}
                        filterOptions={gaFilterOptions}
                        getOptionLabel={(option) => option.label || ""}
                        value={gaSelectedGG1}
                        onChange={(event, newValue) => setGaSelectedGG1(newValue)}
                        isOptionEqualToValue={(option, value) =>
                          option.value.HrControl === value.value.HrControl
                        }
                        size="small"
                        disabled={!gaSelectedDepartment}
                        renderTags={() => null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select GG1 Recruitment"
                            variant="outlined"
                            size="small"
                          />
                        )}
                      />
                      {gaSelectedGG1.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                          {gaSelectedGG1.map((item) => (
                            <Chip
                              key={item.value.HrControl}
                              label={item.value?.HrControl}
                              size="small"
                              onDelete={() =>
                                setGaSelectedGG1((prev) =>
                                  prev.filter(
                                    (g) => g.value.HrControl !== item.value.HrControl
                                  )
                                )
                              }
                            />
                          ))}
                        </div>
                      )}
                      {gaRequiredGG1Count > 0 &&
                        gaHasSelectedGG1 &&
                        !gaIsGG1SelectionValid && (
                          <div style={{ color: "#dc3545", fontSize: "12px" }}>
                            Please select exactly {gaRequiredGG1Count} GG1 recruitment
                            record(s). Selected: {gaSelectedGG1.length}
                          </div>
                        )}

                      <TextField
                        label="Comments"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={gaComments}
                        onChange={(e) => setGaComments(e.target.value)}
                      />
                    </div>
                  </ExpansionPanelContent>
                )}
              </ExpansionPanel>

              {gaSelectedEligibilityId && (
                <div>
                  <strong>{gaSelectedApplicantCount}</strong> total eligible
                  applicant(s) in the selected list.
                </div>
              )}
              {gaJobOpenings > 0 && !gaEligibilityLoader && (
                <div className="d-flex align-items-center gap-2">
                  <strong>
                    {gaNotifyCount} applicants will be notified
                  </strong>
                  <Button
                    color="link"
                    size="sm"
                    className="p-0"
                    disabled={!gaSelectedEligibilityId}
                    onClick={openNotifiedApplicantsModal}
                  >
                    View Applicant to be notified
                  </Button>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            {gaSubmitDisabled && gaSubmitDisabledReason && !gaSubmitLoader && (
              <div className="text-danger me-auto" style={{ fontSize: "13px" }}>
                {gaSubmitDisabledReason}
              </div>
            )}
            <Tooltip
              title={gaSubmitDisabled ? gaSubmitDisabledReason : ""}
              arrow
            >
              {/* A disabled <button> doesn't fire hover events, so the
                  Tooltip needs a span wrapper to still detect the hover. */}
              <span>
                <Button
                  color={gaSubmitDisabled ? "light" : "primary"}
                  onClick={handleGaModalSubmit}
                  disabled={gaSubmitDisabled}
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  {gaSubmitLoader ? (
                    <Spinner size="sm" />
                  ) : (
                    <FontAwesomeIcon icon={faPaperPlaneTop} />
                  )}
                  Generate Now
                </Button>
              </span>
            </Tooltip>{" "}
            <Button
              color="secondary"
              onClick={toggleGaModal}
              disabled={gaSubmitLoader}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={gaGg1ConfirmationModal}
          toggle={() => !gaSubmitLoader && setGaGg1ConfirmationModal(false)}
          centered
        >
          <ModalHeader
            toggle={() => !gaSubmitLoader && setGaGg1ConfirmationModal(false)}
          >
            Confirm Submission
          </ModalHeader>
          <ModalBody>
            You have not selected a Recruitment GG1, eventually a Recruitment GG1 must be assigned to initiate the Named GG1, which you can do later.
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={submitGaWithoutGG1}
              disabled={gaSubmitLoader}
            >
              Yes, Please Proceed
            </Button>
            <Button
              color="secondary"
              onClick={() => setGaGg1ConfirmationModal(false)}
              disabled={gaSubmitLoader}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={gaNotifiedModalOpen}
          toggle={() => setGaNotifiedModalOpen(false)} f
          size="lg"
        >
          <ModalHeader toggle={() => setGaNotifiedModalOpen(false)}>
            Applicants To Be Notified ({gaNotifyCount})
          </ModalHeader>
          <ModalBody>
            {gaApplicantsByEligibility[gaSelectedEligibilityId]?.loading ? (
              <div className="d-flex align-items-center gap-2">
                <Spinner size="sm" /> Loading applicants...
              </div>
            ) : gaApplicantsByEligibility[gaSelectedEligibilityId]?.error ? (
              <div className="text-danger">
                Unable to load applicants for this eligibility list.
              </div>
            ) : (
              <div style={{ maxHeight: "560px", overflowY: "auto" }}>
                <Table size="sm" bordered responsive>
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Application ID</th>
                      <th>Evaluation Rating</th>
                      <th>Application Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(
                      gaApplicantsByEligibility[gaSelectedEligibilityId]
                        ?.applicants ?? []
                    )
                      .slice(0, gaNotifyCount)
                      .map((applicant, index) => (
                        <tr key={applicant.application_id || index}>
                          <td>{applicant.fname}</td>
                          <td>{applicant.lname}</td>
                          <td>{applicant.application_id}</td>
                          <td>{applicant.evaluation_rating}</td>
                          <td>{formatMDY(applicant.application_date)}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setGaNotifiedModalOpen(false)}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          size="lg"
          isOpen={asoModalOpen}
          toggle={() => toggleAsoModal()}
        >
          <ModalHeader toggle={() => toggleAsoModal()}>
            Assign ASO for Certification
            {asoCurrentCert?.CERTIFICATION_PID
              ? ` - ${asoCurrentCert.CERTIFICATION_PID}`
              : ""}
          </ModalHeader>
          <ModalBody>
            {asoLoading ? (
              <div className="d-flex align-items-center gap-2">
                <Spinner size="sm" /> Loading certification details...
              </div>
            ) : (
              <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                <MuiTable stickyHeader>
                  {/* <TableHead>
                    <TableRow>
                      <TableCell width={200}>Role</TableCell>
                      <TableCell>Assign Authority</TableCell>
                    </TableRow>
                  </TableHead> */}
                  <TableBody>
                    <TableRow>
                      <TableCell>ASO</TableCell>
                      <TableCell>
                        <Autocomplete
                          value={asoSelectedHrAso}
                          onChange={(event, value) => setAsoSelectedHrAso(value)}
                          options={asoMembers}
                          getOptionLabel={getAsoMemberOptionLabel}
                          isOptionEqualToValue={(option, value) => option.ID === value.ID}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="ASO"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </MuiTable>
              </TableContainer>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => toggleAsoModal()}
              disabled={asoSubmitLoading}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleAssignAso}
              disabled={asoLoading || asoSubmitLoading}
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              {asoSubmitLoading ? <Spinner size="sm" /> : null}
              Submit
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    </ErrorBoundary>
  );
}

export default CertificationDashboard;
